import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import './Contact.css';

const EMAILJS_SERVICE_ID = 'service_tidothx';
const EMAILJS_TEMPLATE_ID = 'template_40yno8m';
const EMAILJS_PUBLIC_KEY = 'UiKExzyFAeT1tYjGU';

const Apply = () => {
  const [formData, setFormData] = useState({
    name: '',
    contactNo: '',
    fatherName: '',
    email: '',
    message: '',
  });

  const [status, setStatus] = useState({
    loading: false,
    success: false,
    error: '',
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setStatus({
      loading: true,
      success: false,
      error: '',
    });

    try {
      await emailjs.send(
        EMAILJS_SERVICE_ID,
        EMAILJS_TEMPLATE_ID,
        {
          name: formData.name,
          contactNo: formData.contactNo,
          fatherName: formData.fatherName,
          email: formData.email,
          message: formData.message,

          // EmailJS template ke liye
          time: new Date().toLocaleString('en-IN', {
            dateStyle: 'medium',
            timeStyle: 'short',
          }),
        },
        EMAILJS_PUBLIC_KEY
      );

      setStatus({
        loading: false,
        success: true,
        error: '',
      });

      setFormData({
        name: '',
        contactNo: '',
        fatherName: '',
        email: '',
        message: '',
      });
    } catch (err) {
      console.error('EmailJS error:', err);

      setStatus({
        loading: false,
        success: false,
        error: 'Something went wrong. Please try again.',
      });
    }
  };

  return (
    <div className="apply-form">
      <h2>Apply Now</h2>

      <form onSubmit={handleSubmit}>

        {/* Name */}
        <div className="form-group">
          <label htmlFor="name">Name</label>

          <input
            type="text"
            id="name"
            name="name"
            placeholder="Enter your name"
            value={formData.name}
            onChange={handleInputChange}
            required
          />
        </div>

        {/* Contact Number */}
        <div className="form-group">
          <label htmlFor="contactNo">Contact No.</label>

          <input
            type="tel"
            id="contactNo"
            name="contactNo"
            placeholder="Enter contact number"
            value={formData.contactNo}
            onChange={handleInputChange}
            required
          />
        </div>

        {/* Father's Name */}
        <div className="form-group">
          <label htmlFor="fatherName">Father's Name</label>

          <input
            type="text"
            id="fatherName"
            name="fatherName"
            placeholder="Enter father's name"
            value={formData.fatherName}
            onChange={handleInputChange}
            required
          />
        </div>

        {/* Email */}
        <div className="form-group">
          <label htmlFor="email">Email</label>

          <input
            type="email"
            id="email"
            name="email"
            placeholder="Enter email address"
            value={formData.email}
            onChange={handleInputChange}
            required
          />
        </div>

        {/* Message */}
        <div className="form-group">
          <label htmlFor="message">Message</label>

          <textarea
            id="message"
            name="message"
            placeholder="Enter your message"
            value={formData.message}
            onChange={handleInputChange}
            rows="5"
            required
          />
        </div>

        {/* Error */}
        {status.error && (
          <p className="form-error">
            {status.error}
          </p>
        )}

        {/* Success */}
        {status.success && (
          <p className="form-success">
            Application submitted successfully!
          </p>
        )}

        <button
          type="submit"
          disabled={status.loading}
        >
          {status.loading ? 'Submitting...' : 'Submit Application'}
        </button>

      </form>
    </div>
  );
};

export default Apply;
